








import Vue from 'vue';
import Component from 'vue-class-component';
import { InjectReactive } from 'vue-property-decorator';

// Shared types
import { System } from '@coldtec/cos-types';

/**
 *  Component that is responsible for rendering the description of the system.
 */
@Component
export default class SystemDescription extends Vue {

    @InjectReactive('system')
    private system!: System;

    /**
     *  Used to get the description of the system.
     */
    private get description(): string {

        return this.system.description ?? 'Er is helaas geen omschrijving beschikbaar voor dit systeem.';

    }

}
